var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("role-form", {
    ref: "formComponent",
    attrs: {
      "action-type": "edit",
      role: _vm.role,
      "has-permissions-permission":
        _vm.userHasManagementPermission("client_role_permission_store") &&
        _vm.userHasManagementPermission("client_role_permission_destroy"),
      "has-companies-permission":
        _vm.userHasManagementPermission("company_permission_store") &&
        _vm.userHasManagementPermission("company_permission_destroy"),
      "has-users-permission":
        _vm.userHasManagementPermission("user_permission_store") &&
        _vm.userHasManagementPermission("user_permission_destroy"),
      loading: _vm.loading,
      "submission-error": _vm.submissionError,
      previousRolesAndPermissions: _vm.previousRolesAndPermissions
    },
    on: {
      "update-fields-validity": function($event) {
        _vm.fieldsAreValid = $event
      },
      "update-field": _vm.updateFieldValue,
      save: _vm.editRole
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1242f638", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1242f638","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SystemManagement/Accounts/ClientRoles/ClientRoleEdit.vue
// module id = null
// module chunks = 